<footer class="mt-lg-0 pt-lg-0 mt-md-0 pt-md-0 mt-sm-0 mt-0 position-fixed w-100">
  <div class="bg-dark pt-sm-5 pt-5 pb-sm-0">
    <div class="container pt-lg-3">
      <div class="row">
        <div class="col-md-2 offset-lg-1">
          <div class="footer_menu_list">
            <h4 class="text-uppercase text-white text-left oswald_font font_20 bold_500">Information
            </h4>
            <ul class="pl-0 mb-0 mt-2 mt-sm-4 pt-2">
              <li class="mb-2 mb-sm-3"><a class="text-white text-capitalize text-left open_sans bold_400 font_16"
                                          routerLink="/buy-now">Buy</a>
              <li class="mb-2 mb-sm-3"><a class="text-white text-capitalize text-left open_sans bold_400 font_16"
                                          routerLink="/sell-now">Sell</a>
              <li class="mb-2 mb-sm-3"><a class="text-white text-capitalize text-left open_sans bold_400 font_16"
                                          routerLink="/about-us">About
                Us</a>
              <li class="mb-2 mb-sm-3"><a class="text-white text-capitalize text-left open_sans bold_400 font_16"
                                          routerLink="/contact">Contact
                Us</a>
              <li class="mb-0 mb-sm-0"><a class="text-white text-capitalize text-left open_sans bold_400 font_16"
                                          routerLink="/contact">Help</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md-3">
          <div class="footer_menu_list">
            <h4 class="text-uppercase text-white text-left oswald_font font_20 bold_500">Support</h4>
            <ul class="pl-0 mb-0 mt-2 mt-sm-4 pt-2">
              <li class="mb-2 mb-sm-3">
                <a class="text-white text-capitalize text-left open_sans bold_400 font_16" routerLink="/privacy-policy">Privacy</a>
              </li>
              <li class="mb-2 mb-sm-3">
                <a class="text-white text-capitalize text-left open_sans bold_400 font_16" routerLink="/faq">FAQ</a>
              </li>
              <li class="mb-2 mb-sm-3">
                <a class="text-white text-capitalize text-left open_sans bold_400 font_16" routerLink="/app">App</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md-6">
          <div class="latest_news">
            <h4 class="oswald_font font_25 bold_500 text-white text-uppercase">Get Latest news and
              Updates Now</h4>
            <p class="open_sans bold_600 font_16 mt-2">Subscribe To QuickKicks, Get Exclusive Offers.
              </p>
            <form class="mt-5" method="POST">
              <div class="d-flex align-items-end">
                <label class="mb-0">
                  <input
                    class="d-inline-block w-auto border-left-0 border-right-0 border-top-0 border-bottom bg-transparent text-white font_18 open_sans bold_400"
                    name="email" placeholder="Enter your email here"
                    type="email"/>
                </label>
                <button
                  class="text-dark text-center d-inline-block bg-white border subscribe_btn open_sans bold_700 font_16 text-uppercase subscribe-btn"
                  type="submit">
                  Subscribe
                </button>
              </div>
            </form>
          </div>
          <div class="socile-icon-footer">
            <ul>
              <li><a href="https://www.facebook.com/QuickKicksApp/" target="_blank"><i aria-hidden="true" class="fa fa-facebook"></i></a>
              </li>
              <li><a href="https://twitter.com/QuickKicksApp" target="_blank"><i aria-hidden="true" class="fa fa-twitter"></i></a>
              </li>
              <li><a href="https://www.instagram.com/quickkicksapp/" target="_blank"><i aria-hidden="true" class="fa fa-instagram"></i></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright_text text-center border-top d-flex justify-content-between mt-5">
      <div class="container">
        <div class="row d-md-block d-lg-flex">
          <div class="col-md-12 offset-md-0 d-md-flex align-items-center justify-content-md-between">
            <div class="copyright_small_text">
              <p class="open_sans bold_400 font_15 text-white">Copyright © 2020 <a class="d-inline-block text-white"
                                                                                   href="/">QuickKicks</a>.
                All Rights Reserved</p>
            </div>
            <div class="payment_accept">
              <div class="payment_accept_list">
                <ul
                  class="pl-0 mb-0 d-flex align-items-center justify-content-end payment-acceptable-sec">
                  <li class="open_sans bold_400 font_15 text-white pr-3">Accepted Payments :
                  </li>
                  <li class="pr-2"><a href="javascript:void(0);" target="_blank"><img
                    alt="" class="img-fluid" src="/assets/images/visa.png"/></a></li>
                  <li class="pr-2"><a href="javascript:void(0);" target="_blank"><img
                    alt="" class="img-fluid" src="/assets/images/master_card.png"/></a></li>
                  <li class="pr-2"><a href="javascript:void(0);" target="_blank"><img
                    alt="" class="img-fluid" src="/assets/images/american_express.png"/></a>
                  </li>
                  <li class="pr-2"><a href="javascript:void(0);" target="_blank"><img
                    alt="" class="img-fluid" src="/assets/images/discover.png"/></a></li>
                  <li><a href="javascript:void(0);" target="_blank"><img
                    alt="" class="img-fluid" src="/assets/images/paypal.png"/></a></li>
                    <li>
                      <a href="javascript:void(0);" target="_blank"><img style="width:25%"
                        alt="" class="img-fluid" src="/assets/images/crypto-accepted-here.png"/></a>
                    </li>
                </ul>
                <ul>
                  
                </ul>
               
              </div>
             
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>

<div class="switch">
  <input class="switch__input" id="themeSwitch" type="checkbox">
  <label aria-hidden="true" class="switch__label" for="themeSwitch">On</label>
  <div aria-hidden="true" class="switch__marker"></div>
</div>
<!-- top to bottom arrow -->
<a href="#" id="scroll"><span></span></a>
